export enum LeadStatusEnum {
    DOC_AWAITING = "Doc Awaiting",
    HOT_LEAD = "Hot Lead",
    CALL_BACK_LATER = "Call Back later",
    DETAILS_SHARED = "Detailed Shared",
    PLAN_FINALIZED = "Plan Finalized",
    CONTACTED = "Contacted",
    DATA_PRIVACY_CONCERN = "Data Privacy Concern",
    OUT_OF_STATION = "Out of Station",
    DEAD_LEAD = "Dead Lead",
    NOT_INTERESTED = "Not Interested",
    PRICE_ISSUE = "Price Issue",
    DOCUMENTATION_ISSUE = "Documentation Issue",
    QUERY_INFORMATION = "Query/Information",
    CASH = "cash"
}
export const STATUS_TO_COUNT: LeadStatusEnum[] = [
    LeadStatusEnum.HOT_LEAD,
    LeadStatusEnum.CALL_BACK_LATER,
    LeadStatusEnum.DETAILS_SHARED,
    LeadStatusEnum.OUT_OF_STATION,
    LeadStatusEnum.DOC_AWAITING,
    LeadStatusEnum.CONTACTED,
    LeadStatusEnum.PLAN_FINALIZED,
    LeadStatusEnum.DEAD_LEAD,
];
